import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import ElementUI from "element-ui"; //全局引入element
import "element-ui/lib/theme-chalk/index.css"; //全局引入element css
import "@/styles/index.less"; // 全局 css
import VueClipBoard from "vue-clipboard2"; //复制
import base from "./utils/base";
import Vant from "vant";
// 2. 引入组件样式
import "vant/lib/index.css";
import InfiniteLoading from "vue-infinite-loading";
import "babel-polyfill";
import "core-js/stable"; // 引入所有必要的 polyfill
import "regenerator-runtime/runtime"; // 支持 async/await

import "es6-promise/auto";

// import translate from "i18n-jsautotranslate";
// translate.setUseVersion2(); //设置使用v2.x 版本
// translate.selectLanguageTag.show = false; //是否显示切换栏
// translate.listener.start(); //监控页面动态渲染的文本进行自动翻译
// Vue.prototype.$translate = translate;

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(ElementUI);
Vue.use(VueClipBoard);
Vue.use(Vant);
Vue.use(InfiniteLoading);
Vue.prototype.$base = base; //全局方法
Vue.prototype.$imgapi = "https://www.gongyingtech.com/"; //全局方法
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js